<template>
  <section class="titulo relative py-16 px-6 text-center min-h-screen bg-cover bg-center md:bg-center pt-32 pb-32"
           :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/bannerFondo.png')})` }">
    <h1 class="neon-text text-6xl font-extrabold text-gray-800 animate__animated animate__zoomInDown">
      EL GAMING EVOLUCIONA Y TÚ PUEDES SER DUEÑO DESDE EL INICIO
    </h1>
    <div
        class="neon-black flex flex-col md:flex-row justify-center space-y-4 md:space-x-8 mt-12 text-2xl font-bold animate__animated animate__zoomInDown animate__slower">
            <span v-for="(item, index) in items" :key="index" :class="{
                'text-white transition duration-300': true,
                'neon-hover': activeIndex === index
            }">
                {{ item }}
            </span>
    </div>
    <div>
      <h2 class="neon-black text-2xl font-bold text-white mt-12 mb-4">Legends of Interactions — La Frontera Entre
        la Realidad y lo Digital.</h2>
    </div>
  </section>


  <div class="text-center bg-gradient-to-b from-black via-blue-800 to-black">

    <!-- Sección: Beneficios y Oportunidades -->
    <div class=" py-8">
      <div class="max-w-7xl mx-auto px-6 lg:px-8">
        <section class="p-6 px-8 flex flex-col md:flex-row items-center gap-6">
          <!-- Imagen -->
          <img src="@/assets/img/loi-master/mog-logo.jpg" alt="Insignia Gestor" class="w-45 h-9">
          <!-- Texto -->
          <div class="text-center md:text-left">
            <h2 class="font-serif text-2xl font-bold text-white mb-2">🎮 ¿Estás Listo para el Cambio?
            </h2>
            <p class="text-white text-justify">
              Bienvenido a <b>Legends of Interactions</b> el revolucionario videojuego de ciencia ficción
              que te
              sumerge en un mundo donde la fantasía y la realidad se encuentran en el umbral de la
              singularidad digital.
              Aquí, no solo juegas, <b>tienes la oportunidad de poseer tu propio territorio virtual y
              generar ingresos</b> a través de interacciones únicas.
            </p>
          </div>
        </section>
        <button @click.stop="mostrarInformacion()"
                class="mt-4 mb-18 inline-block px-9 py-3 text-white font-bold rounded-lg hover:text-yellow-400 transition-all duration-300 gradient-bg hover:shadow-[0_0_15px_5px_rgba(255,255,0,0.7)]">
          💬&nbsp;Comunicate con un asesor ahora
        </button>

        <!-- Video de YouTube -->
        <div class="mx-auto max-w-4xl px-2 lg:px-8">
          <div class="aspect-w-16 aspect-h-9">
            <iframe class="absolute rounded-lg  top-0 left-0 w-full h-full"
                    src="https://www.youtube.com/embed/ruj4N_ivW2g?si=9hSaSica6-sens9p" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </div>
        </div>

        <!-- Nuevo texto agregado -->
        <h2 class="font-serif text-3xl font-extrabold text-center text-white mt-6 mb-6">
          🌐 Un Mundo sin Límites
        </h2>
        <p class="text-white px-6 text-center">
          En Legends of Interactions, cada jugador define su camino. ¿Serás un explorador en busca de nuevos
          descubrimientos, un estratega capturando territorios
          o un comerciante construyendo un imperio económico?<br><br>
        </p>

        <!-- Ecosistema de juego -->
        <section class="py-12 px-6 max-w-5xl mx-auto text-center">
          <h3 class="font-serif text-3xl font-bold text-yellow-400 mb-8"> Ecosistema de juego: <span
              class="text-white font-extrabold">cuatro mundos, una batalla</span></h3>
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8">
            <div
                class="bg-cyan-700 p-6 rounded-lg shadow-lg bg-cover bg-center transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]"
                :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/fondoAzul.jpg')})` }">
              <h4 class="text-xl font-bold mb-4 text-yellow-400">📈 1. <span class="text-white">Mundo
                                    digital — la arena de los algoritmos</span></h4>
              <p class="text-white font-semibold text-justify">Bienvenido al abismo digital.
                Aquí mandan el código, el blockchain y el metaverso. No es solo un juego: es un sistema
                donde o te adaptas o quedas fuera. Las DAO deciden quién tiene el poder, la moneda del
                juego impone las reglas y las mecánicas determinan al realmente digno.</p>
            </div>

            <div
                class="bg-cyan-700 p-6 rounded-lg shadow-lg bg-cover bg-center transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]"
                :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/fondoAzul.jpg')})` }">
              <h4 class="text-xl font-bold mb-4 text-yellow-400">💬 2. <span class="text-white">Mundo
                                    social — el campo de las manipulaciones</span></h4>
              <p class="text-white font-semibold text-justify">¿Quién dijo que todo lo decide
                el equilibrio? El mundo lo dominan las alianzas, las intrigas, las guerras por
                territorios y las estrategias más astutas. Es un mercado donde no gana quien hace más
                clics, sino quien sabe manejar a las personas.</p>
            </div>

            <div
                class="bg-cyan-700 p-6 rounded-lg shadow-lg bg-cover bg-center transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]"
                :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/fondoAzul.jpg')})` }">
              <h4 class="text-xl font-bold mb-4 text-yellow-400">⚔️ 3. <span class="text-white">Mundo
                                    físico — el mapa del juego en la realidad</span></h4>
              <p class="text-white font-semibold text-justify">Ya no existen fronteras entre lo virtual y
                lo real. Ciudades, países, calles… ahora todo forma parte del juego. El GPS y la
                realidad aumentada han convertido el mundo en un terreno de juego donde cualquiera puede
                dejar su marca..</p>
            </div>

            <div
                class="bg-cyan-700 p-6 rounded-lg shadow-lg bg-cover bg-center transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]"
                :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/fondoAzul.jpg')})` }">
              <h4 class="text-xl font-bold mb-4 text-yellow-400">🪙 4. <span class="text-white">Mundo
                                    económico — la caza del valor</span></h4>
              <p class="text-white font-semibold text-justify">El dinero también es un arma. En este mundo
                mandan la liquidez, la economía dentro del juego y la posibilidad de convertirlo todo en
                dinero real. Aquí no solo se juega: aquí se construye capital..</p>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!--Que a cambiado con este modelo-->
    <section
        class=" rounded-2xl p-8 max-w-6xl mx-auto mt-6 mb-8 flex flex-col md:flex-row items-center gap-8 text-white">

      <!-- Texto principal -->
      <div class="flex-1 text-center md:text-left">
        <h2 class="text-3xl md:text-4xl font-bold">
          ¿<span class="text-yellow-400">QUÉ HA CAMBIADO</span> CON LA LLEGADA DE ESTE MODELO?
        </h2>

        <p class="mt-6 text-gray-200 leading-relaxed text-justify">
          ➡️ Los activos digitales se convirtieron en dinero — ahora puedes jugar y ganar al mismo tiempo.
        </p>

        <p class="mt-4 text-gray-200 leading-relaxed text-justify">
          ➡️ El mundo físico pasó a ser parte de la batalla — ahora las ciudades no son solo ubicaciones, son
          arenas de combate.
        </p>

        <p class="mt-4 text-gray-200 leading-relaxed text-justify">
          ➡️ La economía ahora va más allá del juego — ahora está conectada con el mundo y el mercado reales.
        </p>
      </div>

      <!-- Imagen -->
      <div class="flex">
        <img src="@/assets/img/loi-master/cuatroMundos.jpg" alt="Cacería" class="w-70 rounded-lg">
      </div>

    </section>

    <!-- Nuevo texto debajo -->
    <section class=" rounded-2xl max-w-6xl mx-auto pb-16 text-white text-center">
      <h2 class="text-2xl font-bold mb-6">
        <span class="text-yellow-500">LEGENDS OF INTERACTIONS</span> ha roto todas las fronteras.
      </h2>

      <p class="text-gray-200 leading-relaxed max-w-3xl mx-auto">
        Ya no existe “solo un juego” — hay un nuevo mundo donde lo virtual, lo físico, lo social y lo económico
        se fusionan en una única realidad. <br/>
        ¡Bienvenido al futuro!
      </p>
    </section>
  </div>


  <div class="bg-gradient-to-b from-blue-600 to-gray-600 pt-1 pb-1">
  </div>
  <!-- elijan su experiencia -->
  <div class=" flex flex-col items-center justify-center min-h-screen text-white px-6 bg-cover bg-center"
       :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/banner1.jpg')})` }">
    <img src="@/assets/img/loi-master/logo.jpg" alt="Icono loi" class="h-28 mx-auto">
    <h2 class="neon-black text-3xl font-serif font-bold text-yellow-400 mb-6 relative">
      ELIJAN SU ROL DE EXPERIENCIA
      <span class="absolute -top-2 left-1/2 -translate-x-1/2 w-2 h-2 bg-pink-500 rounded-full"></span>
    </h2>
    <div class="flex flex-col md:flex-row gap-6 w-full max-w-4xl">
      <!-- Creadores de mercado -->
      <div
          class="flex-1 bg-[#1C2541] p-6 rounded-lg shadow-lg border border-gray-600 transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]">
        <h3 class="text-2xl font-bold">MARKET MAKERS</h3>
        <h4 class="text-yellow-400 font-bold mb-4">Negocio basado en un juego</h4>
        <p class="text-gray-300">
          Creen orbes y objetos, pónganlos a la venta en el Marketplace, gestionen el negocio en
          la
          franquicia del juego y obtengan
          <span class="font-bold">remuneraciones.</span>
        </p>
        <p class="text-green-400 font-bold mt-4">✅ ¡Abierto ahora! Participa hoy.</p>
      </div>

      <!-- Masters Card -->
      <div
          class="flex-1 bg-[#1C2541] p-6 rounded-lg shadow-lg border border-gray-600 transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]">
        <h3 class="text-2xl font-bold">MASTERS OF GAME</h3>
        <h4 class="text-yellow-400 font-bold mb-4">Plataforma del Juego como negocio</h4>
        <p class="text-gray-300">
          Diseñen y moldea el espacio del juego, comercia con tierras, recursos y otros objetos del juego,
          emprende en
          el negocio de publicidad dentro del mundo del juego y genera ingresos através de las
          interacciones en tu
          tierra virtual.
        </p>
        <p class="text-green-400 font-bold mt-4">✅ ¡Abierto ahora! Participa hoy.</p>
      </div>

      <!-- Player Card -->
      <div class="flex-1 bg-[#1C2541] p-6 rounded-lg shadow-lg border border-gray-600 opacity-80">
        <h3 class="text-2xl font-bold">PLAYER</h3>
        <h4 class="text-yellow-400 font-bold mb-4">El juego como fuente de aventuras</h4>
        <p class="text-gray-300">
          Disfruta del proceso del juego, explora un mundo de oportunidades únicas, recibe experiencia de
          juego
          totalmente diferente y colecciona raros objetos digitales.
        </p>
        <p class="text-red-400 font-bold mt-4">🚧 Próximamente: Apertura en otoño 2025.</p>
      </div>
    </div>

    <!-- Botón -->
    <button @click.stop="mostrarInformacion()"
            class="mt-8 mb-12 bg-yellow-400 text-gray-900 font-bold py-3 px-8 rounded-full text-lg shadow-lg hover:scale-105 transition-transform">
      Quiero formar parte de <span class="text-blue-800">Legens Of Interactions</span>
    </button>
  </div>

  <div class="bg-gradient-to-b from-gray-600 to-black pt-1 pb-1">
  </div>

  <!-- Video de YouTube -->
  <div class="pt-8 bg-black">
    <div class="mx-auto max-w-4xl px-6 lg:px-8">
      <div class="aspect-w-16 aspect-h-9">
        <iframe class="absolute rounded-lg  top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/WvxL5i44DYI?si=t495ihbG1dQGe_hx" frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
      </div>
    </div>
  </div>

  <!-- MOG y marketplace -->
  <div class="bg-gradient-to-b from-black via-blue-800 to-black py-14 relative z-20 bg-cover bg-center">

    <!-- Economy Section -->
    <section class=" py-12 px-6 bg-cover bg-center">
      <div class="max-w-5xl mx-auto text-center">
        <h2 class="neon-text font-serif text-4xl font-bold text-gray-800"> No Solo Juegues, ¡Invierte y
          Gana!</h2>
        <p class="neon-black mt-4 text-lg text-white">Legends of Interactions ofrece una oportunidad única:
          ser dueño de
          parcelas virtuales
          dentro del juego. Cada parcela genera ingresos pasivos basados en la actividad e interacciones
          que ocurran en
          ella. Mientras otros juegan, tú ganas.</p>
      </div>
      <div class="mt-8 flex justify-center gap-6">

        <img src="@/assets/img/loi-master/mog-logo.jpg" alt="Antallagi Logo"
             class="w-40 h-10 transform hover:scale-110 transition">
      </div>
    </section>


    <!-- Marketplace -->
    <section class=" py-12 px-6 bg-cover bg-center">
      <div class="max-w-5xl mx-auto text-center">
        <h2 class="neon-text font-serif text-4xl font-bold text-gray-800"> Su Negocio en el Marketplace</h2>
        <p class="neon-black mt-4 text-lg text-white">
          Utiliza <span class="text-yellow-400 font-semibold">Antallagí.io</span> para realizar
          intercambios de forma
          segura y construir tu
          imperio digital.<br><br> <span class="text-yellow-400 font-semibold">Antallagí.io</span> es su
          herramienta
          para el comercio de recursos y tierras de juego.
          Gracias a la red blockchain <span class="text-yellow-400 font-semibold">NETSBO</span> , pueden
          gestionar con
          confianza sus activos digitales y llegar a
          un público enorme, escalando su negocio.</p>
      </div>
      <div class="mt-8 flex justify-center gap-6">

        <img src="@/assets/img/loi-master/antallagi-logo.png" alt="Antallagi Logo"
             class="w-40 h-auto transform hover:scale-110 transition">
        <img src="@/assets/img/loi-master/netsbo-logo.jpg" alt="Antallagi Logo"
             class="w-40 h-10 transform hover:scale-110 transition">
      </div>
    </section>
  </div>

  <!-- Llamada a la acción -->
  <div class="bg-gray-600 py-16 relative bg-cover bg-center z-20"
       :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/bannerFondo.png')})` }">
    <!-- CTA -->
    <section class="max-w-3xl mx-auto text-center py-12 px-6">
      <h2 class="neon-text font-serif text-4xl font-bold text-yellow-500"> ¡Sé de los Primeros en un Mundo
        Nuevo!</h2>
      <p class="neon-black mt-4 text-lg text-white">Reserva tu parcela hoy y sé parte de la élite de
        jugadores-inversores.</p>
      <button @click.stop="mostrarInformacion()"
              class="mt-4 mb-18 inline-block px-9 py-3 text-white font-bold rounded-lg hover:text-yellow-400 transition-all duration-300 gradient-bg hover:shadow-[0_0_15px_5px_rgba(255,255,0,0.7)]">
        💬&nbsp;Comunicate con un asesor ahora
      </button>
    </section>
  </div>

  <div ref="modalContacto" class="hidden">
    <div style="color: #1e293b; font-family: 'Segoe UI', sans-serif; animation: fadeInZoom 0.5s ease;">
      <div style="margin-bottom: 1rem; text-align: center;">
        <h2 style="font-size: 1.8rem; font-weight: 700;">{{ participante.nombre || 'Sin nombre' }}</h2>
        <p style="color: #64748b; font-size: 0.95rem;">Información de contacto y enlaces</p>
      </div>
      <div style="padding: 1rem; text-align: left; background-color: #f1f5f9; border-radius: 10px;">
        <p style="margin-bottom: 10px;" v-if="participante.telefono">
          <strong>📲 WhatsApp: </strong>
          <a :href="`https://api.whatsapp.com/send?phone=521${participante.telefono}&text=¡Hola!%20Estoy%20interesado%20en%20conocer%20más%20sobre%20Legends%20of%20Interactions.%20¿Me%20puedes%20dar%20más%20información?`"
             target="_blank" class="text-blue-700">
            <i class="fa-brands fa-whatsapp mr-1"></i>{{ participante.telefono }}
          </a>
        </p>
        <p style="margin-bottom: 10px;" v-if="participante.dato_identificacion">
          <strong>🪪 Datos de identificación: </strong>{{ participante.dato_identificacion }}
        </p>
        <p style="margin-bottom: 10px;" v-if="participante.web_url">
          <strong>🌐 Sitio Web: </strong>
          <a :href="participante.web_url" target="_blank" class="text-blue-700">{{ participante.web_url }}</a>
        </p>
        <p style="margin-bottom: 10px;" v-if="participante.registro_url">
          <strong>📝 Enlace de registro LOI: </strong>
          <a :href="participante.registro_url" target="_blank" class="text-blue-700">
            {{ participante.registro_url }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loi-master3',
  props: {
    participante: {
      type: Object,
      default() {
        return {
          nombre: 'Virtual Shoppin Club',
          telefono: "4271615141",
          dato_identificacion: "",
          web_url: "https://virtualshoppingclub.com",
          registro_url: "https://virtualshoppingclub.com/registro",
        };
      }
    },
    sinParticipantes: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeIndex: 0,
      items: ['Explora', 'Conquista', 'Posee', 'Gana'],
      interval: null
    };
  },
  mounted() {
    this.startAnimation();
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    startAnimation() {
      this.interval = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.items.length;
      }, 1500); // Cambia cada 1.5 segundos
    },

    mostrarInformacion() {
      this.$emit('set-click')

      // Mostrar el modal con SweetAlert2
      this.$swal({
        title: 'Tu Asesor',
        html: this.$refs.modalContacto.innerHTML,
        confirmButtonText: 'Cerrar',
        confirmButtonColor: '#D20103',
        background: '#FFFFFF',
        showClass: {
          popup: 'swal2-show-animate'
        },
        customClass: {
          popup: 'rounded-xl'
        },
        didOpen: () => {
          const style = document.createElement('style')
          style.innerHTML = `@keyframes fadeInZoom {
            0% { opacity: 0; transform: scale(0.9); }
            100% { opacity: 1; transform: scale(1); }
          }`
          document.head.appendChild(style)
        }
      })
    }
  }
};
</script>

<style scoped>
.neon-text {
  text-shadow: 0 0 10px #ffffff, 0 0 20px #ffffff, 0 0 30px #ffffff;
}

.neon-black {
  text-shadow: 0 0 20px #000000, 0 0 10px #000000, 0 0 20px #000000;
}

/* Animación para resaltar la palabra activa */
.neon-hover {
  animation: neonAnimation 1.5s infinite alternate;
}

/* Efecto de brillo y escala */
@keyframes neonAnimation {
  0% {
    text-shadow: 0 0 5px #ff00b7, 0 0 10px #ff00b7, 0 0 15px #ff00b7, 0 0 20px #ff00b7;
    transform: scale(1.2);
  }

  100% {
    text-shadow: 0 0 10px #000000, 0 0 20px #000000, 0 0 30px #000000, 0 0 40px #000000;
    transform: scale(1);
  }
}

@media (max-width: 568px) {
  .titulo h1 {
    font-size: 3.3rem;
  }
}


/* Efecto de colores en el boton */
@keyframes gradientChange {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.gradient-bg {
  background: linear-gradient(45deg, #0008ff, #000a30, #0008ff, #000b35);
  background-size: 400% 400%;
  animation: gradientChange 4s ease infinite;
}
</style>
